module.exports = __webpack_public_path__ + "img/wayfair.41733a3.svg";